export default __webpack_public_path__ + "static/media/cover.b501eadf.jpeg";